var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationMark = function SvgExclamationMark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "exclamation_mark_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".exclamation_mark_svg__exclamationMark0{fill:#231f20}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 669.3c24 0 43.5-19.5 43.5-43.5V43.5C543.5 19.5 524 0 500 0s-43.5 19.5-43.5 43.5v582.2c0 24.1 19.5 43.6 43.5 43.6M500.1 833.7c-.5 0-1 .1-1.6.1-45.9.7-82.5 38.6-81.7 84.5.8 45.5 37.8 81.7 83.2 81.7h1.5c45.9-.8 82.5-38.7 81.7-84.5-.9-45.5-37.9-81.8-83.1-81.8",
    className: "exclamation_mark_svg__exclamationMark0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationMark);
export default ForwardRef;